<template>
  <div id="page">
    <div id="breadcrumb-wrapper">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item" v-for="(breadcrumb, key) in breadcrumbs" v-bind:key="key" v-bind:class="{active: key === (breadcrumbs.length - 1)}">
              <router-link :to="{ name: breadcrumb.path }" v-if="key !== (breadcrumbs.length - 1)">{{ breadcrumb.name }}</router-link>
              <span v-if="key === (breadcrumbs.length - 1)">{{ breadcrumb.name }}</span>
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="container">
      <h1 class="text-center mt-5">{{ title.contact }}</h1>
      <div class="row mt-5 mb-5">
        <div class="col-12- col-md-6 mb-5 mb-md-0">
          <img src="../assets/img/logo.svg" alt="K Food Import Export" class="w-75 m-auto d-block">
        </div>
        <div class="col-12 col-md-6">
          <form v-on:submit.prevent="submitContact">
            <div class="form-group">
              <label for="name">{{ title.label.name }}</label>
              <input type="text" class="form-control" v-bind:placeholder="title.label.name" id="name" v-model="form.name.value" v-bind:class="{'is-invalid': form.name.isError}" v-on:keyup="removeNameError">
              <div class="invalid-feedback" v-if="form.name.isError">
                {{ form.name.message }}
              </div>
            </div>
            <div class="form-group">
              <label for="email">{{ title.label.email }}</label>
              <input type="email" class="form-control" id="email" placeholder="example@email.com" v-model="form.email.value" v-bind:class="{'is-invalid': form.email.isError}" v-on:keyup="removeEmailError">
              <div class="invalid-feedback" v-if="form.email.isError">
                {{ form.email.message }}
              </div>
            </div>
            <div class="form-group">
              <label for="phone">{{ title.label.phone }}</label>
              <input type="tel" class="form-control" id="phone" placeholder="021111111" v-model="form.phone.value" v-bind:class="{'is-invalid': form.phone.isError}" v-on:keyup="removePhoneError">
              <div class="invalid-feedback" v-if="form.phone.isError">
                {{ form.phone.message }}
              </div>
            </div>
            <div class="form-group">
              <label for="message">{{ title.label.message }}</label>
              <textarea id="message" rows="6" class="form-control" v-bind:placeholder="title.label.message" v-model="form.message.value" v-bind:class="{'is-invalid': form.message.isError}" v-on:keyup="removeMessageError"></textarea>
              <div class="invalid-feedback" v-if="form.message.isError">
                {{ form.message.message }}
              </div>
            </div>
            <div class="form-group">
              <button class="btn btn-primary" v-bind:disabled="isBtnDisabled">{{ title.sendBtn }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div id="contact-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 p-0">
            <div class="map-container">
              <div id="map"></div>
            </div>
          </div>
          <div class="col-12 col-md-6 p-4 p-lg-5">
            <div class="row contact-info mb-2" v-if="contactDetail.address">
              <div class="col-2 contact-icon text-right"><i class="icon-home"></i></div>
              <div class="col-10">{{ contactDetail.address }}</div>
            </div>
            <div class="row contact-info mb-2" v-if="contactDetail.fax">
              <div class="col-2 contact-icon text-right"><i class="icon-fax"></i></div>
              <div class="col-10">{{ contactDetail.fax }}</div>
            </div>
            <div class="row contact-info mb-2" v-if="contactDetail.tel">
              <div class="col-2 contact-icon text-right"><i class="icon-phone"></i></div>
              <div class="col-10"><a v-bind:href="'tel:' + contactDetail.tel">{{ contactDetail.tel }}</a></div>
            </div>
            <div class="row contact-info mb-2" v-if="contactDetail.email">
              <div class="col-2 contact-icon text-right"><i class="icon-envelope"></i></div>
              <div class="col-10"><a v-bind:href="'mailto:' + contactDetail.email">{{ contactDetail.email }}</a></div>
            </div>
            <div class="row contact-info mt-4">
              <div class="col-12 row" v-if="contactDetail.line || contactDetail.facebook || contactDetail.shopee || contactDetail.my_shop">
                <a v-bind:href="contactDetail.line_url" target="_blank" class="d-block d-lg-inline-block col-lg-6 mb-2" v-if="contactDetail.line">
                  <img src="../assets/img/line.png" class="img mr-3" alt="Line">
                  <span>{{ contactDetail.line }}</span>
                </a>
                <a v-bind:href="contactDetail.facebook_url" target="_blank" class="d-block d-lg-inline-block mb-2 col-lg-6" v-if="contactDetail.facebook">
                  <img src="../assets/img/fb.png" class="img mr-3" alt="Line">
                  <span>{{ contactDetail.facebook }}</span>
                </a>
                <a v-bind:href="contactDetail.shopee_url" target="_blank" class="d-block d-lg-inline-block mb-2 col-lg-6" v-if="contactDetail.shopee">
                  <img src="../assets/img/shopee.jpg" class="img mr-3" alt="Shopee">
                  <span>{{ contactDetail.shopee }}</span>
                </a>
                <a v-bind:href="contactDetail.my_shop_url" target="_blank" class="d-block d-lg-inline-block mb-2 col-lg-6" v-if="contactDetail.my_shop">
                  <img src="../assets/img/myshop.png" class="img mr-3" alt="Line">
                  <span>{{ contactDetail.my_shop }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Contact',
  data () {
    return {
      contactDetail: [],
      lang: this.$router.history.current.params.lang,
      breadcrumbs: [],
      form: {
        name: {
          isError: false,
          message: '',
          value: ''
        },
        email: {
          isError: false,
          message: '',
          value: ''
        },
        phone: {
          isError: false,
          message: '',
          value: ''
        },
        message: {
          isError: false,
          message: '',
          value: ''
        }
      },
      isBtnDisabled: false,
      title: {
        contact: '',
        label: {
          name: '',
          email: '',
          phone: '',
          message: ''
        },
        sendBtn: ''
      },
      media_path: process.env.MEDIA_PATH
    }
  },
  mounted () {
    this.getContactDetail()

    // Lang
    if (this.lang === 'th') {
      document.title = 'ติดต่อเรา - เคฟู๊ด อิมปอร์ต เอ็กซ์ปอร์ต จำกัด'
      this.title = {
        contact: 'ติดต่อเรา',
        label: {
          name: 'ชื่อ - นามสกุล',
          email: 'อีเมล',
          phone: 'เบอร์โทรศัพท์',
          message: 'ข้อความ'
        },
        sendBtn: 'ส่งข้อความ'
      }
    } else {
      document.title = 'Contact - K Food Import Export Co., Ltd.'
      this.title = {
        contact: 'Contact Us',
        label: {
          name: 'Name',
          email: 'Email',
          phone: 'Phone',
          message: 'Message'
        },
        sendBtn: 'Send'
      }
    }

    this.getBreadcrumb()
  },
  methods: {
    getContactDetail () {
      let self = this
      axios.get(process.env.API_PATH + '/getContactus', {
        params: {
          lang: self.lang
        }
      }).then((response) => {
        self.contactDetail = response.data.result
        if (self.contactDetail.lat && self.contactDetail.lng) {
          self.getMap(self.contactDetail.lat, self.contactDetail.lng, self.contactDetail.address)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    getMap (dataLat, dataLng, dataAddress) {
      const element = document.getElementById('map')
      const center = {lat: parseFloat(dataLat), lng: parseFloat(dataLng)}
      const options = {
        zoom: 16,
        center: center
      }
      // eslint-disable-next-line no-undef
      const map = new google.maps.Map(element, options)

      // eslint-disable-next-line no-undef
      const marker = new google.maps.Marker({
        position: center,
        map: map
      })

      const contentString = '<p>' + dataAddress + '</p>'

      // eslint-disable-next-line no-undef
      const infowindow = new google.maps.InfoWindow({
        content: contentString,
        maxWidth: 300
      })

      marker.addListener('click', function () {
        infowindow.open(map, marker)
      })
    },
    getBreadcrumb () {
      if (this.lang === 'th') {
        this.breadcrumbs = [
          {
            name: 'หน้าแรก',
            path: 'Home'
          },
          {
            name: 'ติดต่อเรา'
          }
        ]
      } else {
        this.breadcrumbs = [
          {
            name: 'Home',
            path: 'Home'
          },
          {
            name: 'Contact'
          }
        ]
      }
    },
    submitContact (e) {
      e.preventDefault()
      let self = this
      self.isBtnDisabled = true
      if (!self.form.name.value) {
        self.form.name.isError = true
        self.form.name.message = 'กรุณากรอกชื่อ'
        self.isBtnDisabled = false
      } else {
        self.form.name.isError = false
        self.form.name.message = ''
      }
      if (!self.form.email.value) {
        self.form.email.isError = true
        self.form.email.message = 'กรุณากรอกอีเมล'
        self.isBtnDisabled = false
      } else {
        self.form.email.isError = false
        self.form.email.message = ''
      }
      if (!self.form.phone.value) {
        self.form.phone.isError = true
        self.form.phone.message = 'กรุณากรอกเบอร์โทรศัพท์'
        self.isBtnDisabled = false
      } else {
        self.form.phone.isError = false
        self.form.phone.message = ''
      }
      if (!self.form.message.value) {
        self.form.message.isError = true
        self.form.message.message = 'กรุณากรอกข้อความ'
        self.isBtnDisabled = false
      } else {
        self.form.message.isError = false
        self.form.message.message = ''
      }
      if (self.form.name.value && self.form.email.value && self.form.phone.value && self.form.message.value) {
        axios.post(process.env.API_PATH + '/sendCustomerContact', {
          name: self.form.name.value,
          email: self.form.email.value,
          phone: self.form.phone.value,
          message: self.form.message.value
        }).then((response) => {
          self.isBtnDisabled = false
          self.form = {
            name: {
              isError: false,
              message: '',
              value: ''
            },
            email: {
              isError: false,
              message: '',
              value: ''
            },
            phone: {
              isError: false,
              message: '',
              value: ''
            },
            message: {
              isError: false,
              message: '',
              value: ''
            }
          }
          alert('ส่งข้อมูลเรียบร้อยแล้ว')
          // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
          self.isBtnDisabled = false
          alert('พบปัญหาการเชื่อมต่อ')
        })
      }
    },
    removeNameError () {
      this.form.name.isError = false
      this.form.name.message = ''
    },
    removeEmailError () {
      this.form.email.isError = false
      this.form.email.message = ''
    },
    removePhoneError () {
      this.form.phone.isError = false
      this.form.phone.message = ''
    },
    removeMessageError () {
      this.form.message.isError = false
      this.form.message.message = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue